// extracted by mini-css-extract-plugin
export var footer = "_qk-5";
export var fulfillmentInput = "_qk-0";
export var shipDateInput = "_qk-1";
export var shipmentModal = "_qk-2";
export var shipmentModalContent = "_qk-3";
export var tableContainer = "_qk-4";